import { OAuthApi } from '@app/modules/core/api/oauth.api';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
@Injectable()
export class UserMockService {
  constructor() {}

  getUserInfo(): Observable<OAuthApi.UserInfo.Response> {
    return of({
      username: 'john.gordon@abc.co.nz',
      domain: 'IQ',
      title: 'Mr',
      firstName: 'John Gordon-Douglas',
      lastName: 'Tippett',
      formattedName: 'Mr John Gordon-Douglas Tippett',
      email: 'eod.testing@fpf.co.nz',
      mobile: '0215542131',
      dateOfBirth: '12/06/1992',
      // passwordStatus: 'FAC'
      passwordStatus: 'ACT' as 'ACT',
      accountStatus: 'ACT' as 'ACT'
    });
  }
}
